import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Navbar from "react-bootstrap/Navbar";
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu";

export default function Navheader(props) {
  const [navbar, setNavbar] = useState(false);

  const changebackground = () => {
    if (window.scrollY >= 10) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  window.addEventListener('scroll', changebackground);
  return (
    <>
      <Container>
        <Navbar
          collapseOnSelect
          expand="lg"
          fixed="top"
          bg="dark"
          variant="dark"
          className={navbar ? 'navbar active' : 'navbar'}
        > 
          <Row className="header-d">
            <Col>
              <Navbar.Brand>
                <a href="https://www.swmc.com/" target="_blank" rel="noreferrer">
                  <img
                    src="https://resources.swmc.com/swmc-images/Homepage/New/SunWest41YearsofTrust-Blue.png"
                    className=" img-fluid w-50 logo-"
                    alt="swmc-logo"
                  />
                </a>
              </Navbar.Brand>
            </Col>
          </Row>
          <UserWayAccessibilityMenu color="black" width={40} height={40}  />
        </Navbar>
      </Container>
    </>
  );
}
